import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const GUEST_KEY = "trustwall_guest_id";

export function getGuestId() {
  let id = localStorage.getItem(GUEST_KEY);
  if (!id) {
    id = "guest-" + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now());
    localStorage.setItem(GUEST_KEY, id);
  }
  return id;
}

const client = axios.create({ baseURL: API });

const TOKEN_KEY = "trustwall_token";
export function getToken() { return localStorage.getItem(TOKEN_KEY); }
export function setToken(t) { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); }

client.interceptors.request.use((config) => {
  config.headers["X-Guest-Id"] = getGuestId();
  const token = getToken();
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

export async function apiRegister(body) { const { data } = await client.post("/auth/register", body); return data; }
export async function apiLogin(body) { const { data } = await client.post("/auth/login", body); return data; }
export async function apiMe() { const { data } = await client.get("/auth/me"); return data; }
export async function fetchHistory() { const { data } = await client.get("/history"); return data; }
export async function fetchHistoryDetail(id) { const { data } = await client.get(`/history/${id}`); return data; }
export async function apiForgotPassword(email) { const { data } = await client.post("/auth/forgot-password", { email }); return data; }
export async function apiResetPassword(token, new_password) { const { data } = await client.post("/auth/reset-password", { token, new_password }); return data; }
export async function apiAdminMessages() { const { data } = await client.get("/admin/messages"); return data; }
export async function apiAdminExpertRequests() { const { data } = await client.get("/admin/expert-requests"); return data; }
export async function apiAdminStripeCleanup() { const { data } = await client.post("/admin/stripe/cleanup-customers"); return data; }
export async function apiMarkMessageRead(id) { const { data } = await client.patch(`/admin/messages/${id}/read`); return data; }
export async function apiExportData() { const { data } = await client.get("/account/export"); return data; }
export async function apiDeleteHistory() { const { data } = await client.delete("/account/history"); return data; }
export async function apiDeleteAccount() { const { data } = await client.delete("/account"); return data; }
export async function apiCheckout(originUrl, plan = "pro") { const { data } = await client.post("/payments/checkout", { origin_url: originUrl, plan }); return data; }
export async function apiPaymentStatus(sessionId) { const { data } = await client.get(`/payments/status/${sessionId}`); return data; }
export async function apiBillingPortal(originUrl) { const { data } = await client.post("/payments/portal", { origin_url: originUrl }); return data; }
export async function apiExpertInfo() { const { data } = await client.get("/expert/info"); return data; }
export async function apiRequestExpert(analysisId, method, originUrl) { const { data } = await client.post("/expert/request", { analysis_id: analysisId, method, origin_url: originUrl }); return data; }
export async function apiBuyCredits(pack, originUrl) { const { data } = await client.post("/expert/credits/checkout", { pack, origin_url: originUrl }); return data; }
export async function apiMyExpertRequests() { const { data } = await client.get("/expert/my-requests"); return data; }
export async function apiExpertQueue(status) { const { data } = await client.get("/expert/queue", { params: { status } }); return data; }
export async function apiExpertVerdict(requestId, body) { const { data } = await client.post(`/expert/queue/${requestId}/verdict`, body); return data; }
export async function apiFamilyGet() { const { data } = await client.get("/account/family"); return data; }
export async function apiFamilyInvite(email) { const { data } = await client.post("/account/family/invite", { email }); return data; }
export async function apiFamilyRemove(email) { const { data } = await client.delete("/account/family/member", { data: { email } }); return data; }
export async function apiSharedResult(id) { const { data } = await client.get(`/public/shared/${id}`); return data; }

export function formatApiError(detail, fallback) {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}

export async function fetchUsage() {
  const { data } = await client.get("/public/usage");
  return data;
}

export async function runDemoCheck() {
  const { data } = await client.post("/public/demo-check");
  return data;
}

export async function runCheck({ inputType, text, url, files, lang }) {
  const form = new FormData();
  form.append("input_type", inputType);
  if (lang) form.append("lang", lang);
  if (text != null) form.append("text", text);
  if (url != null) form.append("url", url);
  (files || []).forEach((f) => form.append("files", f));
  const { data } = await client.post("/public/check", form);
  return data;
}

export async function submitFeedback({ analysisId, helpful, comment }) {
  const { data } = await client.post("/public/feedback", {
    analysis_id: analysisId, helpful, comment: comment || null,
  });
  return data;
}

export function extractError(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  return fallback;
}

export default client;
